import { Chip, Box } from '@mui/material';
import PropTypes from 'prop-types';
// Utils and Helpers
import { SOLIDFI_CARD_STATUS } from 'helpers/constants';
import dayjs from 'helpers/dayjs';
// Assets
import './VirtualCardStatus.css';

const VirtualCardStatus = ({ card }) => {
    const { solidData: solidfiCardData } = card;

    if (!solidfiCardData) {
        return <Chip label="Requested" className="virtual-card-status__chip virtual-card-status__chip-pending fw-bold" />;
    }
    if (card.isCanceled) {
        return <Chip label="Cancelled" className="virtual-card-status__chip virtual-card-status__chip-secondary fw-bold" />;
    }
    if (card.is_system_deactivated || card.isDeactivated) {
        return <Chip label="Frozen" className="virtual-card-status__chip virtual-card-status__chip-danger fw-bold" />;
    }
    if (solidfiCardData.cardStatus === SOLIDFI_CARD_STATUS.PENDING_ACTIVATION) {
        return <Chip label="Pending" className="virtual-card-status__chip virtual-card-status__chip-pending fw-bold" />;
    }
    return (
        <>
            <Chip label="Active" className="virtual-card-status__chip virtual-card-status__chip-success fw-bold" />
            {card?.autoLock && (
                <Box className="card-table-row__secondary-text">Until {dayjs(card?.autoLock).format('MM/DD/YYYY')}</Box>
            )}
        </>
    );
};

VirtualCardStatus.propTypes = {
    card: PropTypes.object.isRequired
};

export default VirtualCardStatus;
